const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M24 12.03c0-.16-.05-.31-.11-.44h.01c-.04-.08-.85-1.69-2.74-3.31-.65-.56-1.44-1.12-2.37-1.61l2.92-2.92c.18-.2.29-.45.29-.72a1.003 1.003 0 00-1.71-.71L16.8 5.81c-1.38-.47-2.97-.78-4.8-.78-4.26-.01-7.27 1.61-9.15 3.24C.96 9.89.15 11.5.11 11.58h.01c-.07.14-.12.28-.12.45 0 .16.05.31.11.44H.1c.04.08.85 1.69 2.74 3.31.65.56 1.44 1.12 2.37 1.61l-2.92 2.92c-.18.19-.29.44-.29.72a1.003 1.003 0 001.71.71l3.49-3.49c1.38.47 2.97.78 4.81.78 4.26.01 7.27-1.62 9.15-3.24 1.89-1.62 2.7-3.23 2.74-3.31h-.01c.06-.15.11-.29.11-.45zM4.15 14.27c-.8-.69-1.38-1.38-1.75-1.89-.09-.13-.17-.25-.24-.35.34-.52 1-1.42 2.06-2.31C5.84 8.37 8.31 7.03 12 7.03c-2.76 0-5 2.24-5 5 0 1.02.31 1.96.83 2.75L6.71 15.9c-1.03-.48-1.88-1.05-2.56-1.63zm15.62.06c-1.62 1.35-4.09 2.69-7.77 2.69 2.76 0 5-2.24 5-5 0-1.02-.31-1.96-.83-2.75l1.12-1.12c1.02.48 1.88 1.05 2.56 1.64.8.69 1.38 1.38 1.75 1.89.09.13.17.25.24.35-.34.51-1.01 1.41-2.07 2.3z"
});

const SvgInvisible = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInvisible, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/invisible.b7f0111c.svg";
export { ForwardRef as ReactComponent };